// MarkdownMessage.jsx — FASE-11 E5-WS4: casca LAZY do renderer markdown.
//
// O pipeline pesado (react-markdown + remark/rehype + Prism ≈ 728K minificado —
// o chunk `markdown` do build) vive em MarkdownMessageImpl.jsx e só baixa quando
// a PRIMEIRA mensagem markdown renderiza. Antes, o import estático puxava o
// chunk inteiro no BOOT do app, mesmo sem nenhuma sessão aberta (achado #31).
//
// O fallback mostra o texto plano (whitespace-pre-wrap) — o conteúdo aparece
// instantâneo e "hidrata" pro markdown rico quando o chunk chega; nada de flash
// vazio. Contrato de props idêntico; todos os importadores seguem intactos.
import { lazy, memo, Suspense } from 'react';

const MarkdownMessageImpl = lazy(() => import('./MarkdownMessageImpl.jsx'));

function MarkdownMessage({ content, highlightSkills = false }) {
  if (!content) return null;
  return (
    <Suspense fallback={<div className="whitespace-pre-wrap text-sm leading-relaxed text-apolo-textPrimary">{content}</div>}>
      <MarkdownMessageImpl content={content} highlightSkills={highlightSkills} />
    </Suspense>
  );
}

// E2-WS3 — memoized (mesma disciplina de antes): content/highlightSkills estáveis
// ⇒ um token streamado em OUTRA mensagem não re-renderiza esta.
export default memo(MarkdownMessage);
